import { useQuery } from "@apollo/client";

import { type ExperienceType } from "../../gql-generated/types";
import {
    type GetUndismissedExperiencesQuery,
    type GetUndismissedExperiencesQueryVariables,
    getUndismissedExperiences,
} from "../api/queries";
import { isLocal } from "../constants";

export const useExperienceDismissalService = (experienceTypes: ExperienceType[]): Set<ExperienceType> => {
    const { data } = useQuery<GetUndismissedExperiencesQuery, GetUndismissedExperiencesQueryVariables>(
        getUndismissedExperiences,
        { variables: { input: { experienceTypes } }, skip: isLocal() },
    );
    const undismissedExperiences = data?.getUndismissedExperiences.experienceTypes ?? [];
    return new Set(undismissedExperiences);
};
